module.exports = __webpack_public_path__ + "img/general_health.8fa7dc52.png";